import React from "react";
import i18n from "../../../../constants/i18n";
import getWatchAlertsStore from "../../../../stores/developer-store/watch-alerts-store";
import Et3LineChart from "../../../../core/et3-chart/Et3LineChart";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const WatchAlertsData = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <Et3LineChart
        chartTitle={i18n.get("USERS")}
        chartLabel={["New Users", "FB Users", "Email Users", "SMS_Users"]}
        chartYAxis={[
          getWatchAlertsStore().newUsersAlerts.get(),
          getWatchAlertsStore().fbUsersAlerts.get(),
          getWatchAlertsStore().emailUsersAlerts.get(),
          getWatchAlertsStore().smsUsersAlerts.get()
        ]}
        chartXAxis={getWatchAlertsStore().arrayXAxis.get()}
        chartColors={["red", "blue", "green", "yellow"]}
        showEmpty={getWatchAlertsStore().showWatchAlerts.get()}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3LineChart
        chartTitle={i18n.get("USERS_LOGIN")}
        chartLabel={["Users LogIn"]}
        chartYAxis={[getWatchAlertsStore().lastLoginUsersAlerts.get()]}
        chartXAxis={getWatchAlertsStore().arrayXAxis.get()}
        chartColors={["red"]}
        showEmpty={getWatchAlertsStore().showWatchAlerts.get()}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3LineChart
        chartTitle={i18n.get("USERS_PAYMENTS")}
        chartLabel={[
          i18n.get("ANDROID_PAYMENTS"),
          i18n.get("IOS_PAYMENTS"),
          i18n.get("WEB_ANDROID_PAYMENTS"),
          i18n.get("WEB_IOS_PAYMENTS")
        ]}
        chartYAxis={[
          getWatchAlertsStore().androidPaymentsAlerts.get(),
          getWatchAlertsStore().iosPaymentsAlerts.get(),
          getWatchAlertsStore().hyperpayAndroidPaymentsAlerts.get(),
          getWatchAlertsStore().hyperpayIosPaymentsAlerts.get()
        ]}
        chartXAxis={getWatchAlertsStore().arrayXAxis.get()}
        chartColors={["red", "blue", "purple", "orange"]}
        showEmpty={getWatchAlertsStore().showWatchAlerts.get()}
      />
    </React.Fragment>
  );
});

export default WatchAlertsData;
